<template>
  <div>
    <van-nav-bar title="抬头信息" left-arrow @click-left="onClickLeft" />
    <van-address-list
      default-tag-text="默认"
      add-button-text="新增抬头"
      v-model="chosenAddressId"
      :list="list"
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>
<script>
import {AddressList, Toast, Row, Col, Icon, NavBar} from 'vant';
export default {
  components: {
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      activeFooter: 3,
      chosenAddressId: '',
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var count = 0;
      var dat
      this.$axios
          .get('/memberBusiness/enterprise/enterpriseList')
              .then(data => {
                var dat = []
                this.list = data.data
                this.list.forEach(function(e){
                  dat.push({id: e.id,name: e.corpName,tel: e.corpNsrsbh,isDefault :(e.isDefault=="1"?true:false),fddCustomerId:e.fddCustomerId})
                  if(e.isDefault==="1"){
                    count = e.id
                  }
                })
                this.list = dat
                this.chosenAddressId = count
              })
    },
    onAdd() {
        this.$router.push({name :"edit", query: { operation: 'add', id: "-1" }});
    },
    onEdit(item, index) {
      this.$axios
          .post('/memberBusiness/fdd/updateStatus',{
            fddCustomerId:item.fddCustomerId,
            corpName: item.name
          })
              .then(data => {
              })
        this.$router.push({name :"edit", query: { operation: 'update', id: item.id }});
    },
    onClickLeft() {
      this.$router.push({ path: "/user" });
    },
  },
};
</script>

<style lang="less" >

.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
